import store from 'src/js/store';
import config from 'src/js/modules/config';

const wonderchat = {
  initChat() {
    const state = store.getState();
    const wonderChatId = config.selectors.getWonderChatId(state);
    const initScript = document.createElement('script');

    initScript.setAttribute('src', 'https://app.wonderchat.io/scripts/wonderchat.js');
    initScript.dataset.name = 'wonderchat';
    initScript.dataset.address = 'app.wonderchat.io';
    initScript.dataset.id = wonderChatId;
    initScript.dataset.widgetSize = 'normal';
    initScript.dataset.widgetButtonSize = 'normal';
    initScript.defer = true;

    document.body.appendChild(initScript);
  },

  hide() {
    const wonderChatElement = document.getElementById('wonderchat-wrapper');

    if (wonderChatElement) {
      wonderChatElement.hidden = true;
    }
  },

  show() {
    const wonderChatElement = document.getElementById('wonderchat-wrapper');

    if (wonderChatElement) {
      wonderChatElement.hidden = false;
    }
  },
};

export default wonderchat;
